import React, { useEffect } from "react"

import "./sportsList.scss"

const SportsList = props => {
  useEffect(() => {
    const sportsListHeight = document.getElementById("sportsList")

    sportsListHeight.addEventListener("scroll", () => {
      if (
        sportsListHeight.scrollTop >
        sportsListHeight.scrollHeight - sportsListHeight.offsetHeight - 100
      ) {
        sportsListHeight.classList.add("scroll")
      } else {
        sportsListHeight.classList.remove("scroll")
      }
    })
  })

  return (
    <div className="sportsList" id="sportsList">
      <div className="sportsList__inner">
        {props.sports.map((data, index) => {
          return (
            <a
              href={data.sport_url.href}
              className="sportList__sport"
              target="_blank"
              rel="noopener noreferrer"
              key={index}
            >
              {props.show_icons && (
                <i
                  className={`icon-${data.sport_icon.split(" ").join("-")}`}
                ></i>
              )}
              {data.sport}
            </a>
          )
        })}
      </div>
    </div>
  )
}

export default SportsList
